import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type SellerPromotionV1 } from '@redteclab/api/clients/bully'

import {
  getFormattedPromotionDiscountedAmountOrPercentage,
  getFormattedPromotionDiscountValueWithCurrency,
} from './productSellerPromotionFormatter'

type ProductSellerPromotionInfoBannerMovMessageProps = {
  sellerName?: string
  sellerPromotion: SellerPromotionV1
}

export const ProductSellerPromotionInfoBannerMovMessage: FC<
  ProductSellerPromotionInfoBannerMovMessageProps
> = ({ sellerName, sellerPromotion }) => {
  const intl = useIntl()

  // WHY ARE WE STILL USING DEPRECATED PROPERTIES?
  //
  // we currently have multiple running marketplace promotions that DO NOT contain the new "conditionType" field
  // until all these promotions expire, get updated by the sellers or we get to do a full sync on all of them,
  // we need to fallback to the deprecated property, otherwise the UI will be broken (http://jira.shop-apotheke.com/browse/WSCNL-10191)
  //
  // prettier-ignore
  // eslint-disable-next-line no-inline-comments, @typescript-eslint/no-deprecated -- Need to support legacy API until Q2 migration
  if (!sellerPromotion.minimumOrderValue) { // NOSONAR
        return null
    }

  return (
    <FormattedMessage
      id="seller.promotion.product.banner.info"
      values={{
        formattedDiscountAmount:
          getFormattedPromotionDiscountedAmountOrPercentage(
            sellerPromotion,
            intl,
          ),
        formattedMovAmount: getFormattedPromotionDiscountValueWithCurrency(
          // eslint-disable-next-line no-inline-comments, @typescript-eslint/no-deprecated -- Need to support legacy API until Q2 migration
          sellerPromotion.minimumOrderValue ?? 0, // NOSONAR
          intl,
        ),
        sellerName,
      }}
    />
  )
}
